import { Table } from '@vwfs-bronson/bronson-react';
import { Skill, isRepositoryManagedSkill } from '../../fes';
import { RowActionsMenu } from '../RowActionsMenu';

const REPOSITORY_MANAGED_HINT =
  'Managed in the skills-library repository. Change it there and merge — the pipeline publishes it automatically.';

export function SkillsTable({
  canEdit,
  onDeleteSkill,
  onEditSkill,
  skills,
  teamNames,
}: {
  canEdit: (skill: Skill) => boolean;
  onDeleteSkill: (skill: Skill) => void;
  onEditSkill: (skill: Skill) => void;
  skills: Skill[];
  teamNames: Map<string, string>;
}) {
  if (skills.length === 0) {
    return <p className="app-empty">No skills found.</p>;
  }

  return (
    <div className="app-table-wrap">
      <Table className="app-table" colored>
        <Table.Thead>
          <Table.Tr>
            <Table.Th>Name</Table.Th>
            <Table.Th>Description</Table.Th>
            <Table.Th>Available to</Table.Th>
            <Table.Th>Source</Table.Th>
            <Table.Th className="app-table-actions-column">Actions</Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {skills.map(skill => {
            const repositoryManaged = isRepositoryManagedSkill(skill);
            const editable = canEdit(skill);

            return (
              <Table.Tr key={skill.skillId || skill.name}>
                <Table.Td>{skill.name}</Table.Td>
                <Table.Td>
                  <span className="app-table-description" title={skill.description}>
                    {skill.description || '-'}
                  </span>
                </Table.Td>
                <Table.Td>
                  {skill.teamId ? teamNames.get(skill.teamId) || skill.teamId : 'All teams'}
                </Table.Td>
                <Table.Td>
                  <span
                    className="app-skill-source"
                    title={repositoryManaged ? REPOSITORY_MANAGED_HINT : undefined}
                  >
                    {repositoryManaged ? 'skills-library' : 'Backoffice'}
                  </span>
                </Table.Td>
                <Table.Td className="app-table-actions-column">
                  <RowActionsMenu
                    deleteDisabled={!editable}
                    deleteDisabledReason={
                      repositoryManaged
                        ? REPOSITORY_MANAGED_HINT
                        : 'This skill is shared with every team and can only be changed by an administrator.'
                    }
                    disabled={!skill.skillId}
                    disabledReason="Skill ID is required for actions"
                    label={`skill ${skill.name || skill.skillId}`}
                    items={repositoryManaged ? [
                      {
                        icon: 'semantic-show',
                        label: 'View',
                        onSelect: () => onEditSkill(skill),
                      },
                    ] : undefined}
                    onDelete={() => onDeleteSkill(skill)}
                    onEdit={() => onEditSkill(skill)}
                  />
                </Table.Td>
              </Table.Tr>
            );
          })}
        </Table.Tbody>
      </Table>
    </div>
  );
}
